import React, { useEffect, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { CommonStyles, Color, CommonProperties } from '../../styles';
import Slide from './Slide';
import TabBar from '../SegmentedControl/TabBar';
import PNRInfo from './PNRInfo';
import PassengerInfo from './PassengerInfo';
import Images from '../../constants/Images';
import AirTripDetail from './AirTripDetail';
import { useNavigation } from '@react-navigation/native';
import { Screens, Modals } from '../../constants/ScreenNames';
import { INFO } from './TripStatus';
import { flightStatusApi } from '../../services/aws/trip.service';
import moment from 'moment';
import useAvailableHeight from '../../utils/useAvailableHeight';
import { scale } from '../../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';

const CHECKIN = 'CHECKIN';
const SEATS = 'SEATS';
const FLIGHTS = 'FLIGHTS';

const airTabItems = [
  { icon: 'circleCheck', second: 'Check In', value: CHECKIN },
  { icon: 'classBasic', second: 'Seats', value: SEATS },
  { icon: 'plane', second: 'Flights', value: FLIGHTS },
];

const getImage = (isMultipleAirline, code) => {
  return isMultipleAirline ? Images.air['36x36']['MultipleAirlinesPNG'] : Images.air['36x36'][code];
};

const getAirlineName = (leg) => {
  return leg.IsMultipleAirline ? 'Multiple Airlines' : leg?.AirSegments[0].AirlineName;
};

const getFlightNumber = (leg) => {
  if (leg.AirSegments.length === 1) {
    return 'Flight' + leg.AirSegments[0].FlightNumber;
  } else {
    return leg.AirSegments.map((segment) => 'Flight ' + segment.FlightNumber).join(', ');
  }
};
const getStartInfo = (leg) => {
  const segment = leg.AirSegments[0];
  return {
    time: segment.DepartTime,
    detail: segment.DepartAirportCityName,
  };
};
const getEndInfo = (leg) => {
  const segment = leg.AirSegments[leg.AirSegments.length - 1];
  return {
    time: segment.ArrivalTime,
    detail: segment.ArrivalAirportCityName,
  };
};
//TODO: Check status, what kind of status exists
const AirPage = ({ leg, passengers }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('AirPage');
  const navigation = useNavigation();
  const image = getImage(leg.IsMultipleAirline, leg.AirlineCode);
  const startInfo = getStartInfo(leg);
  const endInfo = getEndInfo(leg);
  const [flightDetails, setFlightDetails] = useState({});
  const availableHeight = useAvailableHeight(scale(150));

  const onChange = (value) => {
    switch (value) {
      case CHECKIN:
        navigation.navigate(Modals.CheckInWebModal);
        break;
      case SEATS:
        navigation.navigate(Modals.AirSeatModal);
        break;
      case FLIGHTS:
        navigation.navigate(Screens.AirChange);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const getFlightStatus = async (segment) => {
      try {
        if (moment(date).diff(new Date()) < 0) {
          return;
        }

        const flightNumber = segment.FlightNumber;
        const date = moment(segment.DepartureDate).format('MM-DD');
        const vendorCode = segment.AirlineCode;
        const { ArrivalDateTime, DepartureDateTime } = await flightStatusApi(
          date,
          flightNumber,
          vendorCode
        );

        setFlightDetails({
          arrival: {
            gate: ArrivalDateTime?.Gate,
            terminal: ArrivalDateTime?.Terminal,
            bag: '',
          },
          departure: {
            gate: DepartureDateTime?.Gate,
            terminal: DepartureDateTime?.Terminal,
          },
        });
      } catch (e) {
        console.info('error doing flifo request ', e);
      }
    };
    if (leg?.AirSegments?.[0]) {
      getFlightStatus(leg?.AirSegments?.[0]);
    }
  }, [leg]);

  return (
    <ScrollView style={CommonStyles.flex1}>
      <View style={{ height: availableHeight, backgroundColor: 'white' }}>
        <Slide
          image={image}
          type={leg.LegNumber === 1 ? t(tKey('Depart')) : t(tKey('Return'))}
          name={getAirlineName(leg)}
          detail={getFlightNumber(leg)}
          //status={{ value: INFO, label: t(tKey('OnTime')) }}
          startLabel={t(tKey('Departs'))}
          startTime={startInfo.time}
          startDetail={startInfo.detail}
          endLabel={t(tKey('Arrives'))}
          endTime={endInfo.time}
          endDetail={endInfo.detail}
        >
          <AirTripDetail details={flightDetails} />
        </Slide>
        {/* <TabBar primary items={airTabItems} onChange={onChange} style={styles.tabBar} /> */}

        <PNRInfo
          style={CommonStyles.mb3}
          label={t(tKey('AirlineRecordLocator'))}
          value={leg.AirSegments[0].RecordLocator}
        />
        {passengers?.length > 0
          ? passengers.map((passenger, index) => (
              <PassengerInfo
                key={index}
                label={t(tKey('Passenger'))}
                value={passenger.FirstName + ' ' + passenger.LastName}
                //seat="12A"
              />
            ))
          : null}
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  tabBar: {
    borderTopWidth: 0.1,
    borderTopColor: Color.gray,
    ...CommonProperties.py5,
  },
});

export default AirPage;
